define((require) => {
    "use strict";

    var EasingTypes  = require("shared/ui/experience/widgets/animations/EasingTypes"),
        ImprovedView = require("editor/zbone/ImprovedView"),
        template     = require("ui/experience/widgets/animations/zoomOut/ZoomOutAnimationPropertiesView.tpl");

    /**
     * The properties view for a zoom out animation.
     *
     * @class ZoomOutAnimationPropertiesView
     * @constructor
     *
     * @cfg {ZoomOutAnimationModel} model The zoom out animation model being edited.
     */
    return ImprovedView.extend({
        template: template,

        bindings: {
            "#zoomOutEasing": {
                observe: "easing",
                selectOptions: {
                    collection: EasingTypes.getAsArray,
                    labelPath: "displayName",
                    valuePath: "htmlValidName"
                }
            },
            "#delay": {
                observe: "delay",
                onGet: function(value) {
                    return value / 1000;
                },
                onSet: function(value) {
                    return value * 1000;
                }
            },
            "#duration": {
                observe: "duration",
                onGet: function(value) {
                    return value / 1000;
                },
                onSet: function(value) {
                    return value * 1000;
                }
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/animations/zoomOut/ZoomOutAnimationPropertiesView.js